import { render } from "./InstructionComponent.vue?vue&type=template&id=1a91ada8&scoped=true"
import script from "./InstructionComponent.vue?vue&type=script&lang=js"
export * from "./InstructionComponent.vue?vue&type=script&lang=js"

import "./InstructionComponent.vue?vue&type=style&index=0&id=1a91ada8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a91ada8"]])

export default __exports__